/*============================================================================
  SHOWROOM SECTION
==============================================================================*/

function showProduct(product) {    
  if($(product).hasClass('open')) { 
    //$(product).removeClass('open');
    $('.showroom-dialog').removeClass('open');
  } else {
    $('.showroom-dialog').removeClass('open');
    $(product).addClass('open');
  }
}

/* Exe */

$('.showManager').on("click", function() {
  var product = '#' + $(this).attr('aria-controls');
  showProduct(product);
})


/*
$('#addGradingButton').on("click"), function(e) {
  e.preventDefault();
  alert('prsed')
  hideModal('#addedOverlay');
}*/






/*============================================================================
  GRADING ADD MANAGER FROM PRODUCT PAGE
==============================================================================*/

  $("#add-item-form").submit(function(event) {
    hideModal('#addedOverlay');
    hideBackdrop();
    // CASE GRADING OR UPSELL SELECTED => return
    if ($("#add-item-form input.GradingInput:checked").val()) {
      return;
    } 
    // CASE NO OPTIONS SELECTED OR ONLY CERTIFICATE => Go to cart
    else {
      event.preventDefault();
      var cart = $('body').attr('data-cart'); 
      window.location.href = cart;
    }
  });